var NODE_NAME = {
    TABLE: 'table',
    TABLE_CELL: 'table_cell',
    TABLE_HEADER: 'table_header',
    TABLE_ROW: 'table_row',
};
var TABLE_CONFIG = {
    allowTableNodeSelection: false,
    defaultCellWidth: 88,
    cellAttributes: {},
    useTableHeader: true,
};
export { NODE_NAME, TABLE_CONFIG };
//# sourceMappingURL=const.js.map